import React from 'react';
import { withRouteData } from 'react-static';
import moment from 'moment';
import Helmet from 'react-helmet';
import { Link } from '@reach/router';

import Navigation from '../components/WaveNavigation/';
// import Instagram from '../components/Instagram/';
import MailingList from '../components/MailingList/';
import PageHeader from '../components/PageHeader/';

export default withRouteData(({ posts }) => (
  <div>
    <Helmet
      title="Fire Island Ferries | Recent Posts"
      meta={[
        {
          name: 'description',
          content:
            'Fire Island Ferries updates, service notifications, and new schedules.',
        },
        {
          name: 'keywords',
          content: 'Fire Island Ferries, Water Taxi, notifications, updates',
        },
      ]}
    />
    <Navigation />
    <div className="container p-0">
      <PageHeader>
        <h2>Updates</h2>
        <h1>Recent Posts</h1>
      </PageHeader>
    </div>
    <div className="container page">
      <div className="row">
        <div className="col-md-8">
          {posts.map(post => (
            // <li key={post._id}>
            //   <Link to={`/updates/post/${post.slug}/`} >{post.title}</Link>
            // </li>
            <div key={post.slug} className="post">
              <h4>{post.tags.join(', ')}</h4>
              <Link to={`/updates/${post.slug}`}>
                <h2 className={`post-${post.level.toLowerCase()}`}>
                  {post.title}
                </h2>
              </Link>
              <p className="timestamp">
                <i className="far fa-calendar" />{' '}
                {moment(post.publishDate).format('MMMM D, YYYY')}
              </p>
              <p>{post.excerpt}</p>
              <Link
                className={`btn btn-sm ${
                  post.level === 'Danger'
                    ? 'btn-outline-danger'
                    : 'btn-outline-primary'
                } align-bottom`}
                to={`/updates/${post.slug}`}
              >
                More Info
              </Link>
            </div>
          ))}
        </div>
        <div className="col-md-4">
          <h2>Sign Up for Notifications</h2>
          <p>
            Join our mailing list and stay up to date on service disruptions,
            schedules, and more.
          </p>
          <MailingList />
          {/* <h2 className="mb-3"><i className="fab fa-instagram" /> Instagram Updates</h2> */}
          {/* <Instagram /> */}
        </div>
      </div>
    </div>
  </div>
));
